import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import Modal from 'common/modal';
import Avatar from 'common/avatar';
import { casualName } from 'utils';

export default class FundraiserSelect extends Component {
    static propTypes = {
        show: PropTypes.bool.isRequired,
        onSelect: PropTypes.func.isRequired,
        onClose: PropTypes.func.isRequired,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string.isRequired,
                user: PropTypes.shape({
                    firstName: PropTypes.string.isRequired,
                    lastName: PropTypes.string.isRequired,
                    avatar: PropTypes.shape({
                        id: PropTypes.string,
                    }),
                }).isRequired,
            })
        ).isRequired,
    };

    state = {
        query: '',
    };

    get filteredOptions() {
        const { options } = this.props;
        const { query } = this.state;

        if (!query) return options;

        return options.filter(({ user }) => {
            const { firstName = '', lastName = '' } = user;
            const name = `${firstName} ${lastName}`.toLowerCase();
            return name.includes(query.toLowerCase());
        });
    }

    handleQueryChange = e => this.setState({ query: e.target.value });

    render() {
        const { show, onClose, onSelect } = this.props;

        return (
            <Modal isOpen={show} close={onClose}>
                <div className="p-10">
                    <div className="mb-4">
                        <input
                            type="text"
                            className="input-default rounded-full w-full"
                            onChange={this.handleQueryChange}
                            placeholder="Search fundraiser..."
                            autoFocus
                        />
                    </div>

                    {!this.filteredOptions.length && (
                        <p className="text-center gray-400 py-4">No results</p>
                    )}

                    <div className="overflow-auto max-h-1/2-screen">
                        {this.filteredOptions.map(({ id, user }) => {
                            const name = casualName(user.firstName, user.lastName);
                            const hasImage = !!get(user, 'avatar.id');

                            return (
                                <button
                                    key={id}
                                    type="button"
                                    onClick={() => onSelect(user.username)}
                                    className="block w-full text-left text-16 font-medium py-3 px-6 transition hover:bg-blue-10 rounded"
                                    data-testid="fundraiser-option"
                                >
                                    <span className="flex items-center">
                                        {hasImage && (
                                            <Avatar
                                                firstName={user.firstName}
                                                lastName={user.lastName}
                                                imageId={user.avatar.id}
                                                className="w-14 h-14 mr-4 rounded-full"
                                            />
                                        )}
                                        <span className="truncate">{name}</span>
                                    </span>
                                </button>
                            );
                        })}
                    </div>
                </div>
            </Modal>
        );
    }
}
